import React from 'react'
import PowerZoneDashboard from './components/PowerZoneDashboard'

const App: React.FC = () => {
  return (
    <div className="App">
      <PowerZoneDashboard />
    </div>
  )
}

export default App